import { Type } from '@sinclair/typebox';
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["CESG"] = "CESG";
    UserRole["GUEST"] = "GUEST";
})(UserRole || (UserRole = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INVITED"] = "INVITED";
})(UserStatus || (UserStatus = {}));
export const FortnoxUserReviewStatusSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    reviewStatus: Type.String(),
    rank: Type.Number(),
});
export const FortnoxUsersReviewStatusSchema = Type.Array(FortnoxUserReviewStatusSchema);
export const FortnoxUserReviewRankingSchema = Type.Object({
    id: Type.String(),
    ranking: Type.Number(),
});
export const FortnoxUserReviewRankingsSchema = Type.Array(FortnoxUserReviewRankingSchema);
export const UpdateInvoiceReviewersSchema = Type.Object({
    reviewers: FortnoxUserReviewRankingsSchema,
});
export const FortnoxUserModel = Type.Object({
    id: Type.String(),
    email: Type.String(),
    fortnoxId: Type.Union([Type.String(), Type.Null()]),
    name: Type.String(),
    phone: Type.Union([Type.String(), Type.Null()]),
    role: Type.Enum(UserRole),
    status: Type.Enum(UserStatus),
    createdAt: Type.Date(),
    updatedAt: Type.Date(),
});
export const GetFortnoxUserSchema = Type.Object({
    id: Type.String(),
});
export const CreateFortnoxGuestDetailsSchema = Type.Object({
    email: Type.String(),
    name: Type.String(),
    role: Type.Enum(UserRole),
});
export const CreateFortnoxGuestResponseSchema = FortnoxUserModel;
export const ListFortnoxUsers = Type.Array(FortnoxUserModel);
export var FortnoxUserReviewStatusType;
(function (FortnoxUserReviewStatusType) {
    FortnoxUserReviewStatusType["APPROVE"] = "APPROVE";
    FortnoxUserReviewStatusType["PENDING"] = "PENDING";
    FortnoxUserReviewStatusType["CONTEST"] = "CONTEST";
    FortnoxUserReviewStatusType["PARK"] = "PARK";
})(FortnoxUserReviewStatusType || (FortnoxUserReviewStatusType = {}));
